import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue';
import ShowShipments from "../views/shipments/ShowShipments";
import UpdatePods from "../views/shipments/UpdatePods";
import ErrorPage from "../views/ErrorPage";
import JobNotEditableUserInfo from "../views/JobNotEditableUserInfo";
import ViewShipment from  "../views/shipments/ViewShipment"
import Booking from "../views/booking/Booking"
import PreJob from "../views/booking/PreJob"
import Stock from "../views/warehouse/Stock"
import WarehouseJobs from "@/views/warehouse/WarehouseJobs";
import SKUHistory from "@/views/warehouse/SKUHistory";
import PickStock from "@/views/warehouse/PickStock";
import PurchaseOrder from "@/views/orders/PurchaseOrder"
import store from '@/store';
import BrowsePicks from "@/views/warehouse/BrowsePicks.vue";

const routes = [
  {
    // Main home page ??
    path: '/',
    name: 'home',
    component: ShowShipments
  },
  {// Internal from shipments grid
    path: '/viewshipment/:mode/:id(\\d+)',
    name: 'viewshipment',
    component: ViewShipment
  },
  {
    path: '/',
    name: 'routeGuardErrorPage',
    component: ErrorPage,
    // beforeEnter: (to, from) => {
    //  store.state.caughtURL = to.redirectedFrom?.fullPath;
    // }
  },
  {
    path: '/noedit',
    name: 'jobNotEditableUserInfo',
    component: JobNotEditableUserInfo,
    // beforeEnter: (to, from) => {
    //   store.state.caughtURL = from.fullPath;
    // }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.dashboard) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/showshipments',
    name: 'showshipments',
    component: ShowShipments,
    // async beforeEnter (to, from, next)  {
    //
    //   try {
    //
    //     let m = await store.state.mainMenu
    //     if (m) {
    //       next();
    //
    //     }
    //
    //   } catch(e) {
    //
    //     next ({name: 'routeGuardErrorPage'});
    //   }
    //
    // }

  },
  {
    path: '/stock',
    name: 'stock',
    component: Stock,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/purchaseorder/:id(new||browse)',
    name: 'purchaseorder',
    component: PurchaseOrder,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.orderItems.find(x => x.id === to.params.id).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/booking/:section/:id(\\d+||new)',
    name: 'booking',
    component: Booking,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.freightItems.find(x => x.section === to.params.section).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/quote/:id',
    name: 'quote',
    component: () => import('@/views/quotes/Quote'),
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.quoteItems.find(x => x.id === to.params.id).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/documents/SearchDocuments'),
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.documents) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/reports/Reports'),
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.reports) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/skuhistory',
    name: 'skuhistory',
    component: SKUHistory,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },

  {
    path: '/warehousejobs',
    name: 'warehousejobs',
    component: WarehouseJobs,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/browsepicks',
    name: 'browsepick',
    component: BrowsePicks,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/updatepods',
    name: 'updatepods',
    component: UpdatePods,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/pickstock/:id',
    name: 'pickstock',
    component: PickStock,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.warehouseItems.find(x => x.view === to.name).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/prejob/:section/:id(\\d+||new)',
    name: 'prejob',
    component: PreJob,
    // beforeEnter: (to, from) => {
    //   if(!store.state.mainMenu.agentItems.find(x => x.section === to.params.section).active) return {name: 'routeGuardErrorPage'};
    // }
  },
  {
    path: '/:catchAll(.*)',
    name: 'errorPage',
    component: ErrorPage,
    // beforeEnter: (to, from) => {
    //   store.state.caughtURL = to.fullPath;
    // }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
